// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1wtXz","modalFooterButton":"ModalNotes_modalFooterButton__d1t0c"};